/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CompanyShipmentQuote } from "./CompanyShipmentQuote";
import {
  CompanyShipmentQuoteFromJSON,
  CompanyShipmentQuoteFromJSONTyped,
  CompanyShipmentQuoteToJSON,
  CompanyShipmentQuoteToJSONTyped,
} from "./CompanyShipmentQuote";
import type { AgentTaskRun } from "./AgentTaskRun";
import {
  AgentTaskRunFromJSON,
  AgentTaskRunFromJSONTyped,
  AgentTaskRunToJSON,
  AgentTaskRunToJSONTyped,
} from "./AgentTaskRun";
import type { ShipmentImperfection } from "./ShipmentImperfection";
import {
  ShipmentImperfectionFromJSON,
  ShipmentImperfectionFromJSONTyped,
  ShipmentImperfectionToJSON,
  ShipmentImperfectionToJSONTyped,
} from "./ShipmentImperfection";
import type { ManageQuotesTabData } from "./ManageQuotesTabData";
import {
  ManageQuotesTabDataFromJSON,
  ManageQuotesTabDataFromJSONTyped,
  ManageQuotesTabDataToJSON,
  ManageQuotesTabDataToJSONTyped,
} from "./ManageQuotesTabData";
import type { ConfigurationData } from "./ConfigurationData";
import {
  ConfigurationDataFromJSON,
  ConfigurationDataFromJSONTyped,
  ConfigurationDataToJSON,
  ConfigurationDataToJSONTyped,
} from "./ConfigurationData";
import type { BillingTabData } from "./BillingTabData";
import {
  BillingTabDataFromJSON,
  BillingTabDataFromJSONTyped,
  BillingTabDataToJSON,
  BillingTabDataToJSONTyped,
} from "./BillingTabData";
import type { DurationInfo } from "./DurationInfo";
import {
  DurationInfoFromJSON,
  DurationInfoFromJSONTyped,
  DurationInfoToJSON,
  DurationInfoToJSONTyped,
} from "./DurationInfo";
import type { ClaimsTabData } from "./ClaimsTabData";
import {
  ClaimsTabDataFromJSON,
  ClaimsTabDataFromJSONTyped,
  ClaimsTabDataToJSON,
  ClaimsTabDataToJSONTyped,
} from "./ClaimsTabData";
import type { NotesTabData } from "./NotesTabData";
import {
  NotesTabDataFromJSON,
  NotesTabDataFromJSONTyped,
  NotesTabDataToJSON,
  NotesTabDataToJSONTyped,
} from "./NotesTabData";
import type { DocumentsTabData } from "./DocumentsTabData";
import {
  DocumentsTabDataFromJSON,
  DocumentsTabDataFromJSONTyped,
  DocumentsTabDataToJSON,
  DocumentsTabDataToJSONTyped,
} from "./DocumentsTabData";
import type { ShipmentReport } from "./ShipmentReport";
import {
  ShipmentReportFromJSON,
  ShipmentReportFromJSONTyped,
  ShipmentReportToJSON,
  ShipmentReportToJSONTyped,
} from "./ShipmentReport";
import type { TrackingLine } from "./TrackingLine";
import {
  TrackingLineFromJSON,
  TrackingLineFromJSONTyped,
  TrackingLineToJSON,
  TrackingLineToJSONTyped,
} from "./TrackingLine";
import type { OperationsTask } from "./OperationsTask";
import {
  OperationsTaskFromJSON,
  OperationsTaskFromJSONTyped,
  OperationsTaskToJSON,
  OperationsTaskToJSONTyped,
} from "./OperationsTask";
import type { Sticky } from "./Sticky";
import {
  StickyFromJSON,
  StickyFromJSONTyped,
  StickyToJSON,
  StickyToJSONTyped,
} from "./Sticky";

/**
 *
 * @export
 * @interface ViewShipmentDataForHubble
 */
export interface ViewShipmentDataForHubble {
  /**
   *
   * @type {CompanyShipmentQuote}
   * @memberof ViewShipmentDataForHubble
   */
  shipment: CompanyShipmentQuote;
  /**
   *
   * @type {Array<TrackingLine>}
   * @memberof ViewShipmentDataForHubble
   */
  trackingLines: Array<TrackingLine>;
  /**
   *
   * @type {ManageQuotesTabData}
   * @memberof ViewShipmentDataForHubble
   */
  manageQuotesTab: ManageQuotesTabData;
  /**
   *
   * @type {DocumentsTabData}
   * @memberof ViewShipmentDataForHubble
   */
  documentsTab: DocumentsTabData;
  /**
   *
   * @type {BillingTabData}
   * @memberof ViewShipmentDataForHubble
   */
  billingTab: BillingTabData;
  /**
   *
   * @type {NotesTabData}
   * @memberof ViewShipmentDataForHubble
   */
  notesTab: NotesTabData;
  /**
   *
   * @type {string}
   * @memberof ViewShipmentDataForHubble
   */
  suggestedTrackingLine: string;
  /**
   *
   * @type {string}
   * @memberof ViewShipmentDataForHubble
   */
  accountNumber: string;
  /**
   *
   * @type {ConfigurationData}
   * @memberof ViewShipmentDataForHubble
   */
  _configuration: ConfigurationData;
  /**
   *
   * @type {ShipmentReport}
   * @memberof ViewShipmentDataForHubble
   */
  shipmentReport: ShipmentReport;
  /**
   *
   * @type {string}
   * @memberof ViewShipmentDataForHubble
   */
  carrierDisplayName?: string | null;
  /**
   *
   * @type {string}
   * @memberof ViewShipmentDataForHubble
   */
  shipmentId: string;
  /**
   *
   * @type {DurationInfo}
   * @memberof ViewShipmentDataForHubble
   */
  durationInfo: DurationInfo;
  /**
   *
   * @type {ClaimsTabData}
   * @memberof ViewShipmentDataForHubble
   */
  claimsTab: ClaimsTabData;
  /**
   *
   * @type {Array<OperationsTask>}
   * @memberof ViewShipmentDataForHubble
   */
  operationsTasks: Array<OperationsTask>;
  /**
   *
   * @type {Array<AgentTaskRun>}
   * @memberof ViewShipmentDataForHubble
   */
  recentAgentTaskRuns?: Array<AgentTaskRun> | null;
  /**
   *
   * @type {Array<Sticky>}
   * @memberof ViewShipmentDataForHubble
   */
  companyStickies?: Array<Sticky> | null;
  /**
   *
   * @type {Array<ShipmentImperfection>}
   * @memberof ViewShipmentDataForHubble
   */
  shipmentImperfections?: Array<ShipmentImperfection> | null;
  /**
   *
   * @type {boolean}
   * @memberof ViewShipmentDataForHubble
   */
  perfectShipmentTracked?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof ViewShipmentDataForHubble
   */
  deliveryAmazonReferenceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof ViewShipmentDataForHubble
   */
  deliveryAmazonShipmentId?: string | null;
}

/**
 * Check if a given object implements the ViewShipmentDataForHubble interface.
 */
export function instanceOfViewShipmentDataForHubble(
  value: object,
): value is ViewShipmentDataForHubble {
  if (!("shipment" in value) || value["shipment"] === undefined) return false;
  if (!("trackingLines" in value) || value["trackingLines"] === undefined)
    return false;
  if (!("manageQuotesTab" in value) || value["manageQuotesTab"] === undefined)
    return false;
  if (!("documentsTab" in value) || value["documentsTab"] === undefined)
    return false;
  if (!("billingTab" in value) || value["billingTab"] === undefined)
    return false;
  if (!("notesTab" in value) || value["notesTab"] === undefined) return false;
  if (
    !("suggestedTrackingLine" in value) ||
    value["suggestedTrackingLine"] === undefined
  )
    return false;
  if (!("accountNumber" in value) || value["accountNumber"] === undefined)
    return false;
  if (!("_configuration" in value) || value["_configuration"] === undefined)
    return false;
  if (!("shipmentReport" in value) || value["shipmentReport"] === undefined)
    return false;
  if (!("shipmentId" in value) || value["shipmentId"] === undefined)
    return false;
  if (!("durationInfo" in value) || value["durationInfo"] === undefined)
    return false;
  if (!("claimsTab" in value) || value["claimsTab"] === undefined) return false;
  if (!("operationsTasks" in value) || value["operationsTasks"] === undefined)
    return false;
  return true;
}

export function ViewShipmentDataForHubbleFromJSON(
  json: any,
): ViewShipmentDataForHubble {
  return ViewShipmentDataForHubbleFromJSONTyped(json, false);
}

export function ViewShipmentDataForHubbleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ViewShipmentDataForHubble {
  if (json == null) {
    return json;
  }
  return {
    shipment: CompanyShipmentQuoteFromJSON(json["shipment"]),
    trackingLines: (json["trackingLines"] as Array<any>).map(
      TrackingLineFromJSON,
    ),
    manageQuotesTab: ManageQuotesTabDataFromJSON(json["manageQuotesTab"]),
    documentsTab: DocumentsTabDataFromJSON(json["documentsTab"]),
    billingTab: BillingTabDataFromJSON(json["billingTab"]),
    notesTab: NotesTabDataFromJSON(json["notesTab"]),
    suggestedTrackingLine: json["suggestedTrackingLine"],
    accountNumber: json["accountNumber"],
    _configuration: ConfigurationDataFromJSON(json["configuration"]),
    shipmentReport: ShipmentReportFromJSON(json["shipmentReport"]),
    carrierDisplayName:
      json["carrierDisplayName"] == null
        ? undefined
        : json["carrierDisplayName"],
    shipmentId: json["shipmentId"],
    durationInfo: DurationInfoFromJSON(json["durationInfo"]),
    claimsTab: ClaimsTabDataFromJSON(json["claimsTab"]),
    operationsTasks: (json["operationsTasks"] as Array<any>).map(
      OperationsTaskFromJSON,
    ),
    recentAgentTaskRuns:
      json["recentAgentTaskRuns"] == null
        ? undefined
        : (json["recentAgentTaskRuns"] as Array<any>).map(AgentTaskRunFromJSON),
    companyStickies:
      json["companyStickies"] == null
        ? undefined
        : (json["companyStickies"] as Array<any>).map(StickyFromJSON),
    shipmentImperfections:
      json["shipmentImperfections"] == null
        ? undefined
        : (json["shipmentImperfections"] as Array<any>).map(
            ShipmentImperfectionFromJSON,
          ),
    perfectShipmentTracked:
      json["perfectShipmentTracked"] == null
        ? undefined
        : json["perfectShipmentTracked"],
    deliveryAmazonReferenceId:
      json["deliveryAmazonReferenceId"] == null
        ? undefined
        : json["deliveryAmazonReferenceId"],
    deliveryAmazonShipmentId:
      json["deliveryAmazonShipmentId"] == null
        ? undefined
        : json["deliveryAmazonShipmentId"],
  };
}

export function ViewShipmentDataForHubbleToJSON(
  json: any,
): ViewShipmentDataForHubble {
  return ViewShipmentDataForHubbleToJSONTyped(json, false);
}

export function ViewShipmentDataForHubbleToJSONTyped(
  value?: ViewShipmentDataForHubble | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipment: CompanyShipmentQuoteToJSON(value["shipment"]),
    trackingLines: (value["trackingLines"] as Array<any>).map(
      TrackingLineToJSON,
    ),
    manageQuotesTab: ManageQuotesTabDataToJSON(value["manageQuotesTab"]),
    documentsTab: DocumentsTabDataToJSON(value["documentsTab"]),
    billingTab: BillingTabDataToJSON(value["billingTab"]),
    notesTab: NotesTabDataToJSON(value["notesTab"]),
    suggestedTrackingLine: value["suggestedTrackingLine"],
    accountNumber: value["accountNumber"],
    configuration: ConfigurationDataToJSON(value["_configuration"]),
    shipmentReport: ShipmentReportToJSON(value["shipmentReport"]),
    carrierDisplayName: value["carrierDisplayName"],
    shipmentId: value["shipmentId"],
    durationInfo: DurationInfoToJSON(value["durationInfo"]),
    claimsTab: ClaimsTabDataToJSON(value["claimsTab"]),
    operationsTasks: (value["operationsTasks"] as Array<any>).map(
      OperationsTaskToJSON,
    ),
    recentAgentTaskRuns:
      value["recentAgentTaskRuns"] == null
        ? undefined
        : (value["recentAgentTaskRuns"] as Array<any>).map(AgentTaskRunToJSON),
    companyStickies:
      value["companyStickies"] == null
        ? undefined
        : (value["companyStickies"] as Array<any>).map(StickyToJSON),
    shipmentImperfections:
      value["shipmentImperfections"] == null
        ? undefined
        : (value["shipmentImperfections"] as Array<any>).map(
            ShipmentImperfectionToJSON,
          ),
    perfectShipmentTracked: value["perfectShipmentTracked"],
    deliveryAmazonReferenceId: value["deliveryAmazonReferenceId"],
    deliveryAmazonShipmentId: value["deliveryAmazonShipmentId"],
  };
}
